import { TransportPlan } from '@savgroup-front-common/core/api/Claim/getClaimGroupTransportPlanQuery';

export const hasRelayPointApi = (transportPlan: TransportPlan): boolean =>
  transportPlan.hasRelayPointApi !== false;
